import { render } from "./Setting.vue?vue&type=template&id=0789a42c&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"

import "./Setting.vue?vue&type=style&index=0&id=0789a42c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0789a42c"

export default script